var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27783",
    "data-name": "Group 27783",
    transform: "translate(-908 -342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_268",
    "data-name": "Ellipse 268",
    transform: "translate(908 342)",
    fill: "none",
    stroke: "#f25845",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 30.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27782",
    "data-name": "Group 27782",
    transform: "translate(931.137 365.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32006",
    "data-name": "Path 32006",
    d: "M-6384.759-24365.234l17.146,17.145",
    transform: "translate(6384.759 24365.234)",
    fill: "none",
    stroke: "#f25845",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32007",
    "data-name": "Path 32007",
    d: "M-6367.613-24365.234l-17.146,17.145",
    transform: "translate(6384.759 24365.234)",
    fill: "none",
    stroke: "#f25845",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.f6fded08b1ab90eed3ec982a57c56469.svg";
export { ForwardRef as ReactComponent };